import { Pipe, PipeTransform } from '@angular/core';
import { HardcodedLabels } from '@shared/constants/hardcoded-labels';

@Pipe({ name: 'hardcodedTranslation'})
export class HardcodedTranslationPipe implements PipeTransform {

  public transform(key: string) {
    let value: string = null;

    value = HardcodedLabels?.find(x => x.key === key)?.value;

    return value;
  }
}
